<template>
  <div v-auto-animate class="h-full space-y-5 md:h-fit">
    <FilterDropdown
      v-for="(filter, index) in filterStore.filters"
      :key="`filter_${index}`"
      v-model="filterStore.selectedFilterOptions[index]"
      :index="index"
      :label="filter.meta.name"
      :options="filterStore.filterOptions[index]"
      show-predefined-show-text
      v-bind="{
        showTooltip,
        loading,
        showPrices,
        showAbove,
      }"
      @update:model-value="
        $emit('changed-filter', index, filterStore.selectedFilterOptions[index])
      "
    />

    <template v-if="showRadioButtons">
      <FilterRadioButtons
        :label="sizeStore.preferredSizes?.meta?.name"
        :options="sizeStore.preferredSizeOptions"
        :custom-size-radio-button-id="customSizeRadioButtonId"
        v-bind="{
          loading,
        }"
        @changed-filter="$emit('changed-filter')"
      />

      <TotalPriceDisplay class="hidden md:flex" />
    </template>

    <!-- If product doesn't have filters, the SKUs are the filter -->
    <FilterDropdown
      v-if="
        sizeStore.hasMoreThanOneFilteredSize &&
        !configuratorStore.isConfiguratorOpen
      "
      v-model="sizeStore.selectedSizeOption"
      :options="Object.values(sizeStore.filteredAvailableSizeOptions)"
      :label="$t('pages.collection.size.label')"
      is-sku-filter
      v-bind="{
        showTooltip,
        loading,
        showPrices,
        showAbove,
      }"
      @update:model-value="
        $emit('changed-filter', undefined, sizeStore.selectedSizeOption)
      "
    />
  </div>
</template>

<script setup lang="ts">
import FilterDropdown from '@/pages/ProductPage/partials/ProductFilters/FilterDropdown.vue';
import { useFilterStore } from '@/stores/Configurator/FilterStore.ts';
import FilterRadioButtons from '@/pages/ProductPage/partials/ProductFilters/FilterRadioButtons.vue';
import { useSizeStore } from '@/stores/Configurator/SizeStore.ts';
import TotalPriceDisplay from '@/pages/ProductPage/partials/Configurator/ConfiguratorLayout/ConfiguratorFooter/TotalPriceDisplay.vue';
import { useConfiguratorStore } from '@/stores/Configurator/ConfiguratorStore.ts';

defineEmits(['changed-filter']);

const configuratorStore = useConfiguratorStore();
const filterStore = useFilterStore();
const sizeStore = useSizeStore();

defineProps({
  showTooltip: {
    type: Boolean,
    required: false,
    default: true,
  },

  loading: {
    type: Boolean,
    required: false,
    default: false,
  },

  showPrices: {
    type: Boolean,
    required: false,
    default: true,
  },

  showRadioButtons: {
    type: Boolean,
    required: false,
    default: true,
  },

  showAbove: {
    type: Boolean,
    required: false,
    default: false,
  },

  customSizeRadioButtonId: {
    type: String,
    required: false,
    default: 'custom-size-radio-button-desktop',
  },
});
</script>
